<template>
    <div class="certificate container">
        <div v-if="showCert">
            <div class="d-flex align-items-start flex-column">
                <p class="certificate-type">Diploma del curso</p>
                <h2 class="course-name">{{certData.course}}</h2>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-6">
                    <div class="card border-card" style="background-color:#fefefe">
                        <h5 class="card-header text-center bg-primary text-white">Universidad Galileo reconoce el siguente logro del Estudiante</h5>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 order-md-1">
                                    <h4 class="card-title">{{certData.name}} {{certData.lastname}}</h4>
                                    <p class="mb-1 text-muted">Ha completado con éxito, recibió una calificación aprobatoria, y recibió un Certificado de finalización en</p>
                                    <h5>{{certData.course}}</h5>
                                    <button class="btn btn-outline-primary" @click="downloadItem(certData)">Descargar</button>
                                </div>
                                <div class="col-md-6 order-md-2">
                                    <span class="text-info">DATOS DEL DIPLOMA</span>
                                    <ul class="list-group mb-3">
                                        <li class="list-group-item d-flex justify-content-between lh-condensed">
                                            <div>
                                                <h6 class="my-0">TIPO</h6>
                                                <small class="text-muted">{{this.courseInfo.type}}</small>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between lh-condensed">
                                            <div style="overflow:auto">
                                                <h6 class="my-0">IDENTIFICACIÓN:</h6>
                                                <small class="text-muted">{{currentId}}</small>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between lh-condensed">
                                            <div>
                                                <h6 class="my-0">EMITIDO EN:</h6>
                                                <small class="text-muted">{{certData.createdAt}}</small>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between lh-condensed">
                                            <div>
                                                <h6 class="my-0">ESFUERZO:</h6>
                                                <small class="text-muted">{{courseHours}} horas</small>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-12 col-lg-6">
                    <object :data="certData.certUri + pdfPreviewToolbarOptions" type="application/pdf" width="100%" height="100%"></object>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="card w-100 shadow-card" style="background-color:#fefefe">
                <div class="card-header bg-primary text-white">
                    <h5 class="my-0">Diploma digital no válido</h5>
                </div>
                <div class="card-body">
                    <h2 class="card-title px-4 pt-2">Ingresa un código de diploma digital válido</h2>
                    <p class="card-text px-4">No se ha encontrado ningun Diploma digital asociado, ingrese un código de Diploma digital válido</p>
                    <hr class="mt-2 mb-3"/>
                    <div class="py-4 px-4">
                    <h4>¿Buscas algún diploma digital en específico?</h4>
                    <p class="text-muted">Asegurate que el código de Diploma digital ingresado sea válido</p>
                    </div>
                </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-6">
                    <h5>
                        <strong>Acerca de Universidad Galileo</strong>
                    </h5>
                    <p class="text-muted">
                        Universidad Galileo es una entidad educativa superior, producto de 40 años de labor y esfuerzo constante de un selecto grupo de profesionales encabezado por el Doctor Eduardo Suger Cofiño, Ph.D., fundador y Rector
                    </p>
                </div>
                <div class="col-md-3">
                    <h5>
                        <strong>Acerca de Diplomas Digitales</strong>
                    </h5>
                    <p class="text-muted">El diploma digital es un documento que se genera a través de un sistema informático</p>
                </div>
                <div class="col-md-3">
                    <h5>
                        <strong>Validando Diplomas Digitales</strong>
                    </h5>
                    <p class="text-muted">Cuando un diploma digital es emitido dispone de un código seguro de verificación para comprobar la validez de la firma y la integridad del documento</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/firestore'
import Promise from 'bluebird'
import JsZip from 'jszip'
import FileSaver from 'file-saver'

export default {
    name: "Certificate",
    data() {
        return {
            certId: null,
            docId: null,
            certImg: null,
            certData: {},
            showCert: false,
            pdf: undefined,
            courseHours: 20,
            currentId: this.$route.params.id,
            courseInfo: {},
            pdfPreviewToolbarOptions: '#toolbar=0&navpanes=0&scrollbar=0',
            filesToDownload: [],
            ownerName: "",
        }
    },
    created() {
        if (this.currentId) {
            let subId = this.currentId.split('.')
            this.certId = subId[0]
            this.docId = subId[1]
            this.getCert()
        }
    },
    methods: {
        async getCert() {
            let certRef = firebase.firestore().collection("entities").doc(this.docId).collection("certificates").doc(this.certId)

            try {
                let certDoc = await certRef.get()
                if (!certDoc.exists) {
                    console.log('No such document!');
                } else {
                    this.certData = certDoc.data()
                    if (this.certData.status == 1) {
                        this.timeConverter(this.certData.issued)
                        this.showCert = true
                        //Obtener info de curso
                        let courseInfo = firebase.firestore().collection("courses").doc(this.docId)
                        let courseDoc = await courseInfo.get();
                        if (courseDoc) {
                            this.courseInfo = courseDoc.data();
                        }
                    }
                }
            } catch (error) {
                console.log('Error getting document', error)
                this.certData = ""
            }

        },
        timeConverter(datetimestamp){
            let dateVar = new Date(datetimestamp.seconds * 1000)
            let months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
            let year = dateVar.getFullYear()
            let month = months[dateVar.getMonth()]
            let date = dateVar.getDate()
            let time = date + ' ' + month + ' ' + year
            this.certData.createdAt = time
        },
        download(url){
          return fetch(url).then(resp =>
                resp.blob()
            ).catch(err => {
                console.log(err)
            });
        },
        downloadByGroup (files, files_per_group=10) {
            return Promise.map(
                files,
                async file => {
                    return await this.download(file.downloadUrl)
                },
                {concurrency: files_per_group}
            );
        },
        exportZip (blobs) {

          const zip = JsZip();
          const filesQueue = this.filesToDownload;
          blobs.forEach((blob, i) => {
              zip.file(`${filesQueue[i].ownerName}-${filesQueue[i].id}.${filesQueue[i].fileExtension}`, blob);
          });
          zip.generateAsync({type: 'blob'}).then(zipFile => {
            const fileName = `Diplomas ${this.ownerName}.zip`;
            return FileSaver.saveAs(zipFile, fileName);
          });
        },
        downloadItem(items) {
          this.$toasted.show('Descarga de diploma inicializada, no recargue su navegador', {
            type : 'info',
            duration : null
          });
          const ownerName = `${this.certData.name} ${this.certData.lastname}`
          const filePdf = {
            downloadUrl: items.certUri,
            fileExtension: "pdf",
            id: this.currentId,
            ownerName
          }
          this.filesToDownload.push(filePdf);

          const fileSig = {
            downloadUrl: items.sigUri,
            fileExtension: "sig",
            id: this.currentId,
            ownerName
          }
          this.filesToDownload.push(fileSig);
          this.ownerName = ownerName

          return this.downloadByGroup(this.filesToDownload, 5).then(this.exportZip);
        }
    },
}

</script>

<style scoped>
.border-card {
    border: 1px solid rgba(0,0,0,.125) !important;
    border-radius: .25rem;
}
.course-name {
    margin-top: 10px;
    margin-bottom: 50px;
    font-weight: 300;
}
.certificate-type {
    margin-top: 0;
    margin-bottom: 0;
    font-size: .75rem;
    line-height: 1.125rem;
    text-transform: none;
    font-weight: 400;
}
.cert-btn {
    padding: 2em 0;
    text-align: right;
}
.user-data {
    background-color: #d6edf6;
    color: #1f1f1f;
    padding: 4em 2em;
}
.color-ug {
    color: #b89a59;
}

.shadow-card {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}

.card, .card .card-header {
    border-radius: 0;
    border-bottom: 0;
}

.border-ug {
    border: 1px solid #b89a59;
    z-index: 10;
}

.border-ug {
    margin: 10px;
    position: relative;
}

.firm h6, .firm h5 {
    font-size: 14px;
}

.firm h5 {
    font-weight: bold;
}

.firm hr {
    margin-top: .3rem;
    margin-bottom: .3rem;
}

.certificate-ug {
    position: relative;
    margin: 10px;
}

.card {
    width: 100%;
    border: 0;
    z-index: 12;
    background-color: transparent;
}

.card .card-header {
    background: transparent;
}

.item-left, .item-right {
    position: absolute;
    top: 0;
    bottom: 0;
}

.item-left {
    width: 90%;
    background-color: #fff;
    z-index: 9;
    left: 0;
}

.item-right {
    width: 10%;
    background-color: #212529;
    z-index: 9;
    right: 0;
}

.certificate-left {
    width: 90%;
    height: 20px;
    background-color: #fff;;
}

.certificate-right {
    width: 10%;
    height: 20px;
    background-color: #212529;
}

.c-left {
    width: 90%;
}

.c-right {
    width: 10%;
    background-color: #000000;
}

.certificate-ug2 {
    position: relative;
}

.border-ab, .border-ab2 {
    position: absolute;
    width: 97%;
    height: 97%;
    top: 3px;
    left: 6px;
    right: 0px;
    bottom: 0;
    margin: 10px;
    border: 1px solid #b89a59;
    z-index: 11;
}

.border-ab2 {
    top: 14px;
    left: 16px;
    width: 95%;
    height: 94%;
}

.text-mini {
    font-size: 12px;
}

.montserrat-regular {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
}

.montserrat-medium {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
}

.title-name {
    font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Certificate.vue